import Layout, { LayoutTemplates } from '../../layouts/layouts';

/**
 * Disconnected from server page
 * @component
 */
const DisconnectedPage = () => {
	return (
		<Layout layout={LayoutTemplates.raw} title="Server connection error">
			<div className="centered-block">
				<div className="text">
					<strong>Couldn&apos;t connect to server</strong>
					<br />
					<br />
					<span>Please try again later.</span>
				</div>
			</div>
		</Layout>
	);
};

DisconnectedPage.propTypes = {};

export default DisconnectedPage;
